import React from 'react';
import { Logo } from './Logo';
import { contact, offices } from '../data/site';
import { services } from '../data/services';
const companyLinks = [{
  label: 'About Us',
  href: '#about'
}, {
  label: 'Our Team',
  href: '#team'
}, {
  label: 'Clients',
  href: '#clients'
}, {
  label: 'FAQs',
  href: '#faqs'
}, {
  label: 'Contact',
  href: '#contact'
}];
export function Footer() {
  return <footer className="border-t border-line bg-parchment pt-20" data-id="element-127" data-mp="3ufa7afwmplqj">
      <div className="mx-auto max-w-[1240px] px-6" data-id="element-128" data-mp="3ucxnryb833bd">
        <div className="grid gap-12 pb-16 md:grid-cols-2 lg:grid-cols-4" data-id="element-129" data-mp="38z70lzg0p09">
          <div data-id="element-130" data-mp="3lelzw41qqjmm">
            <Logo data-id="element-131" data-mp="3lf58uv9exxoi" />
            <p className="mt-6 max-w-xs text-[14px] leading-relaxed text-ink-70" data-id="element-132" data-mp="3ldkf37uxairp">
              Your final stop for audit, tax and finance consulting.
            </p>
            <div className="mt-6 space-y-1 font-mono text-[12px] text-ink-70" data-id="element-133" data-mp="29ynnprb9nhh6">
              <p data-id="element-134" data-mp="2ey9yzv7jannc">
                {contact.phonePrimary} / {contact.phoneSecondary}
              </p>
              <a href={`mailto:${contact.email}`} className="block hover:text-green-dark" data-id="element-135" data-mp="3l9k7pidf7xfx">
                {contact.email}
              </a>
            </div>
          </div>

          <nav aria-label="Services" data-id="element-136" data-mp="3gcjzb0t3miln">
            <h2 className="font-mono text-[10px] uppercase tracking-[0.14em] text-ink-50" data-id="element-137" data-mp="3v89cc9gb3le8">
              Services
            </h2>
            <ul className="mt-5 space-y-3" data-id="element-138" data-mp="3q7u1ppnesrzy">
              {services.map(service => <li key={service.id} data-id="element-139" data-mp="81yx4j0q5y3z">
                  <a href="#services" className="text-[14px] text-ink-70 transition-colors hover:text-green-dark" data-id="element-140" data-mp="80xi63gl8rgz">
                    {service.name}
                  </a>
                </li>)}
            </ul>
          </nav>

          <nav aria-label="Company" data-id="element-141" data-mp="cvtn246xb9bi">
            <h2 className="font-mono text-[10px] uppercase tracking-[0.14em] text-ink-50" data-id="element-142" data-mp="qt03hs46cvxk">
              Company
            </h2>
            <ul className="mt-5 space-y-3" data-id="element-143" data-mp="mt7r14bnu5mx">
              {companyLinks.map(link => <li key={link.href} data-id="element-144" data-mp="tw5wy2alzikm">
                  <a href={link.href} className="text-[14px] text-ink-70 transition-colors hover:text-green-dark" data-id="element-145" data-mp="tt09ssljiqrj">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-146" data-mp="18m3q6wneaygo">
            <h2 className="font-mono text-[10px] uppercase tracking-[0.14em] text-ink-50" data-id="element-147" data-mp="1clmc9vqydfl3">
              Locations
            </h2>
            <ul className="mt-5 space-y-5" data-id="element-148" data-mp="1hjw6a30xya54">
              {offices.map(office => <li key={office.label} data-id="element-149" data-mp="1mj8uos7gnp9t">
                  <p className="font-mono text-[11px] uppercase tracking-[0.08em] text-green-dark" data-id="element-150" data-mp="1mkbi2q5kr9kz">
                    {office.label}
                  </p>
                  <p className="mt-1 text-[13px] leading-relaxed text-ink-70" data-id="element-151" data-mp="3obom7czpxdfz">
                    {office.address}
                  </p>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="flex flex-col gap-2 border-t border-line py-7 font-mono text-[11px] text-ink-50 sm:flex-row sm:items-center sm:justify-between" data-id="element-152" data-mp="2ag5eqppkvag4">
          <p data-id="element-153" data-mp="25mkhizvt6khz">
            © {new Date().getFullYear()} Premier Advisory Services Ltd. All rights
            reserved.
          </p>
          <p data-id="element-154" data-mp="1woi75tq6qfi1">{contact.website}</p>
        </div>
      </div>
    </footer>;
}